export default "__VITE_ASSET__kDGW3ucv__"